(() => {
  const init = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const track = root.querySelector('[data-gallery-track]');
    const slides = [...root.querySelectorAll('[data-gallery-image]')];
    const thumbs = [...root.querySelectorAll('[data-thumbnail]')];
    const previous = root.querySelector('[data-gallery-prev]');
    const next = root.querySelector('[data-gallery-next]');
    const count = root.querySelector('[data-gallery-count]');
    const dialog = root.querySelector('[data-zoom]');
    const enlarged = root.querySelector('[data-zoom-content]');
    const enlarge = root.querySelector('[data-enlarge]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let active = 0;
    let galleryWidth = track.clientWidth;
    let returnFocus = null;
    const refresh = () => {
      if (!track.clientWidth || track.clientWidth !== galleryWidth) return;
      active = Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / track.clientWidth)));
      thumbs.forEach((thumb, index) => index === active ? thumb.setAttribute('aria-current', 'true') : thumb.removeAttribute('aria-current'));
      previous.disabled = active === 0;
      next.disabled = active === slides.length - 1;
      count.textContent = `${active + 1} / ${slides.length}`;
    };
    const move = (index) => {
      const bounded = Math.min(slides.length - 1, Math.max(0, index));
      track.scrollTo({left: bounded * track.clientWidth, behavior: reduced.matches ? 'auto' : 'smooth'});
      const thumb = thumbs[bounded];
      if (thumb) thumb.parentElement.scrollTo({left: Math.max(0, thumb.offsetLeft - thumb.parentElement.offsetLeft - thumb.parentElement.clientWidth / 2 + thumb.clientWidth / 2), behavior: reduced.matches ? 'auto' : 'smooth'});
    };
    const openZoom = (index, source) => {
      if (!dialog.showModal) return false;
      const original = slides[index].querySelector('img');
      const img = document.createElement('img');
      img.src = slides[index].href;
      img.alt = original.alt;
      img.width = original.naturalWidth || original.width;
      img.height = original.naturalHeight || original.height;
      enlarged.replaceChildren(img);
      returnFocus = source;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      return true;
    };
    previous.hidden = next.hidden = enlarge.hidden = false;
    previous.addEventListener('click', () => move(active - 1));
    next.addEventListener('click', () => move(active + 1));
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', event => {event.preventDefault();move(index)}));
    slides.forEach((slide, index) => slide.addEventListener('click', event => {if (openZoom(index, slide)) event.preventDefault()}));
    enlarge.addEventListener('click', () => openZoom(active, enlarge));
    root.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {if (event.target === dialog) dialog.close()});
    dialog.addEventListener('keydown', event => {if (event.key === 'Escape') event.stopPropagation()});
    root.addEventListener('keyup', event => {if (event.key === 'Escape') event.stopPropagation()});
    dialog.addEventListener('close', () => {document.documentElement.style.overflow = '';returnFocus?.focus({preventScroll:true})});
    let frame;
    track.addEventListener('scroll', () => {cancelAnimationFrame(frame);frame=requestAnimationFrame(refresh)}, {passive:true});
    track.addEventListener('keydown', event => {
      if (event.target !== track) return;
      if (['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) {
        event.preventDefault();
        move(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    const resize = new ResizeObserver(() => {galleryWidth=track.clientWidth;track.scrollTo({left:active*galleryWidth,behavior:'instant'});refresh()});
    resize.observe(track);
    refresh();
    const quantity = root.querySelector('input[name="quantity"]');
    root.querySelectorAll('[data-quantity-change]').forEach(button => {
      button.hidden=false;
      button.addEventListener('click', () => {
        if (button.dataset.quantityChange === '1') quantity.stepUp(); else quantity.stepDown();
        quantity.dispatchEvent(new Event('change', {bubbles:true}));
      });
    });
    const variantSelect=root.querySelector('[data-variant-select]');
    variantSelect?.addEventListener('change', () => {
      const option=variantSelect.selectedOptions[0];
      const submit=root.querySelector('.product-form__submit');
      const available=option.dataset.available==='true';
      root.querySelectorAll('[data-product-price]').forEach(element=>element.textContent=option.dataset.price);
      submit.disabled=!available;
      submit.querySelector('[data-submit-label]').textContent=available?submit.dataset.addLabel:submit.dataset.soldOutLabel;
      submit.removeAttribute('aria-disabled');
      submit.querySelector('.sold-out-message')?.classList.add('hidden');
      submit.querySelector('[data-submit-label]').classList.remove('hidden');
      root.querySelector('.product-form__error-message-wrapper')?.setAttribute('hidden','');
      quantity.min=option.dataset.min || '1';
      quantity.step=option.dataset.step || '1';
      if(option.dataset.max) quantity.max=option.dataset.max; else quantity.removeAttribute('max');
      if(!quantity.checkValidity()) quantity.value=quantity.min;
      const payment=root.querySelector('.gp-payment');
      if(payment) payment.hidden=!available;
      const url=new URL(window.location.href);url.searchParams.set('variant',option.value);window.history.replaceState({},'',url);
    });
    const rail=root.querySelector('[data-game-rail]');
    if(rail){
      const previousGames=root.querySelector('[data-games-prev]');
      const nextGames=root.querySelector('[data-games-next]');
      const gameCards=[...root.querySelectorAll('[data-game-card]')];
      const railRefresh=()=>{previousGames.disabled=rail.scrollLeft<=2;nextGames.disabled=rail.scrollLeft>=rail.scrollWidth-rail.clientWidth-2};
      const railMove=(direction)=>{const first=gameCards[0];const distance=first?first.getBoundingClientRect().width+20:rail.clientWidth;rail.scrollBy({left:direction*distance,behavior:reduced.matches?'auto':'smooth'})};
      previousGames.hidden=nextGames.hidden=false;
      previousGames.addEventListener('click',()=>railMove(-1));
      nextGames.addEventListener('click',()=>railMove(1));
      rail.addEventListener('scroll',railRefresh,{passive:true});
      rail.addEventListener('keydown',event=>{if(event.target!==rail)return;if(['ArrowLeft','ArrowRight','Home','End'].includes(event.key)){event.preventDefault();if(event.key==='Home'||event.key==='End')rail.scrollTo({left:event.key==='Home'?0:rail.scrollWidth,behavior:reduced.matches?'auto':'smooth'});else railMove(event.key==='ArrowLeft'?-1:1)}});
      const railResize=new ResizeObserver(railRefresh);railResize.observe(rail);railRefresh();
      root.addEventListener('shopify:section:unload',()=>railResize.disconnect(),{once:true});
    }
    const sticky=root.querySelector('[data-sticky]');
    const buy=root.querySelector('[data-buy-area]');
    const refreshSticky=()=>{sticky.hidden=buy.getBoundingClientRect().bottom>=0};
    const observer=new IntersectionObserver(refreshSticky,{threshold:0});
    observer.observe(buy);
    window.addEventListener('scroll',refreshSticky,{passive:true});
    window.addEventListener('resize',refreshSticky);
    refreshSticky();
    sticky.querySelector('a').addEventListener('click',()=>{sticky.hidden=true});
    root.addEventListener('shopify:section:unload',()=>{observer.disconnect();resize.disconnect();window.removeEventListener('scroll',refreshSticky);window.removeEventListener('resize',refreshSticky)},{once:true});
  };
  const setup=(scope=document)=>scope.querySelectorAll('[data-game-product]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup());else setup();
  document.addEventListener('shopify:section:load',event=>setup(event.target));
})();
